import { z } from "zod/v4";

export const ResearchVerificationSchema = z.object({
  nameValidity: z.enum(["valid", "invalid", "unknown"]),
  personMatch: z.enum(["confirmed", "possible", "different"]),
  businessMatch: z.enum(["confirmed", "possible", "different"]),
  dealBusinessMatch: z.enum(["confirmed", "possible", "different"]),
  relationship: z.enum(["owner", "operator", "employee", "broker", "unknown"]),
  factSupported: z.boolean(),
  confidence: z.number().min(0).max(1).optional(),
  requiresHumanReview: z.boolean().optional(),
  reviewQuestion: z.string().max(500).optional(),
  identityBasis: z
    .enum(["identifier", "corroborated_context", "reasoned_match", "uncertain"])
    .optional(),
  reason: z.string().min(1).max(500),
  quotes: z
    .array(
      z.object({
        observationId: z.string(),
        text: z.string().min(5).max(1500),
        purpose: z.enum(["name", "identity", "fact", "deal"]),
      }),
    )
    .max(12),
  identifiers: z
    .array(
      z.object({
        kind: z.enum(["email", "phone", "businessName", "address"]),
        value: z.string().min(1).max(300),
        observationId: z.string(),
      }),
    )
    .max(8),
});

export type ResearchVerification = z.infer<typeof ResearchVerificationSchema>;
export const RESEARCH_VERIFICATION_JSON_SCHEMA = z.toJSONSchema(
  ResearchVerificationSchema,
);
